import React from 'react';
import SectionTab from 'constants/SectionTab';
import ContactUs from 'modules/contactform';
import AboutUs from 'modules/aboutus';
import FAQ from 'modules/faq';
import Top10 from 'modules2/top10';
import Location from 'modules2/location';
import Station from 'modules2/station';
import { Genres, GenreStation } from 'modules2/genres';
import SearchResultsPage from 'modules2/search';
import {
  PopularChannel,
  WorkPlaceChannel,
  FiveStar,
} from 'modules2/popularChannel';
// import { RadioFavourite, RadioHistory } from 'modules2/history';
import { MainCard } from 'modules2/history/components';

const ContentArea = (props) => {
  const { currentTab, position } = props;

  const getActiveSection = () => {
    switch (currentTab) {
      case SectionTab.RadioFavourite:
        return <MainCard />;

      default:
        return <MainCard />;
    }
  };

  const getActiveTab = () => {
    switch (currentTab) {
      case SectionTab.Contact:
        return <ContactUs />;
      case SectionTab.About:
        return <AboutUs />;
      case SectionTab.Faq:
        return <FAQ />;
      case SectionTab.Features:
        return <PopularChannel />;
      case SectionTab.PopularChannel:
        return <PopularChannel />;
      case SectionTab.WorkPlaceChannel:
        return <WorkPlaceChannel />;
      case SectionTab.FiveStar:
        return <FiveStar />;
      case SectionTab.Location:
        return <Location />;
      case SectionTab.Station:
        return <Station />;
      case SectionTab.Genres:
        return <Genres />;
      case SectionTab.GenreStation:
        return <GenreStation />;
      // case SectionTab.RadioFavourite:
      //   return <MainCard />;
      // case SectionTab.RadioHistory:
      //   return <RadioHistory />;
      case SectionTab.RadioTop10:
        return <Top10 />;
      case SectionTab.SearchRadio:
        return <SearchResultsPage />;
      default:
        return <PopularChannel />;
    }
  };

  return position === 'top' ? (
      <div className="main-content-area" id="top-content-area">{getActiveSection()}</div>
  ) : (
      <div className="main-content-area" id="main-content-area">{getActiveTab()}</div>
  );
};

export default ContentArea;
